import styled from "styled-components";
export const TopNavStyle = styled.div`
    margin: 0.3rem 1rem;
    padding: 0.1rem 1.5rem;
    border-radius: var(--border-radius);
    box-shadow: 0 2px 5px var(--box-shadow);
    overflow: unset;
        filter: drop-shadow(10px);
    background: var(--white);
    svg {
        font-size: 2rem;
        color: var(--dark-gray);
        &.logout {
            color: var(--light-blue);
        }
    }
`;
